import React, { useState, useEffect, useRef, useMemo } from "react";
//assets
import arrowOff from "img/QuoteDropDownOff.svg";
import arrowOn from "img/QuoteDropDownOn.svg";
//components
import { VisibilityConditional } from "components/VisibilityConditional";
import { Column, Row } from "components/Layout/Grid";
import Text from "components/Text";
//interfaces
import { MultiCategoryHandler, OptionsDropdownProps } from "./interface";
//styles
import "./style.scss";

const QuoteStatusFilter: React.FC<MultiCategoryHandler> = (props) => {
  const {
    selectedBionexoStatus,
    selectedQuoteCategory,
    dashboardQuoteFilter,
    selectedViveoStatus,
    selectedOrderStatus,
    orderRadioSelected,
    setStatusBionexo,
    setQuoteCategory,
    notReloadStatus,
    setOrderStatus,
    setCurrentPage,
    setStatusViveo,
    setLength,
    length
  } = props;
  const [open, setOpen] = useState<boolean>(false);
  const [style, setStyle] = useState<string>("none");
  const [arrow, setArrow] = useState<string>(arrowOff);
  const [searchListBionexo, setSearchListBionexo] = useState<OptionsDropdownProps[]>([]);
  const [searchListViveo, setSearchListViveo] = useState<OptionsDropdownProps[]>([]);
  const [searchQuoteCategoryOptions, setSearchQuoteCategoryOptions] = useState<OptionsDropdownProps[]>([]);
  const [searchOrderOptions, setSearchOrderOptions] = useState<OptionsDropdownProps[]>();
  const [selectedGridOption, setSelectedGridOption] = useState<0 | 1 | 2>(0);

  const dropdownMenu: any = useRef(null);

  useMemo(() => {
    if (dashboardQuoteFilter) {
      setSearchListBionexo(dashboardQuoteFilter.bionexoOptions);
      setSearchListViveo(dashboardQuoteFilter.viveoOptions);
      setSearchQuoteCategoryOptions(dashboardQuoteFilter.categoryMafraOptions);
      setSearchOrderOptions(dashboardQuoteFilter.orderOptions);
    }
  }, [dashboardQuoteFilter]);

  const handleOpenCloseDropDownMenu = () => {
    if (open === false) {
      setOpen(true);
      setStyle("block");
      setArrow(arrowOn);
    } else {
      setOpen(false);
      setStyle("none");
      setArrow(arrowOff);
    }
  };

  const closeOpenMenus = (e: any) => {
    if (dropdownMenu?.current && open && !dropdownMenu?.current.contains(e.target)) {
      handleOpenCloseDropDownMenu();
    }
  };

  useEffect(() => {
    setLength!(selectedBionexoStatus.length + selectedViveoStatus.length + selectedQuoteCategory.length);
  }, [selectedBionexoStatus, selectedViveoStatus]);

  useEffect(() => {
    orderRadioSelected && selectedOrderStatus && setLength!(selectedOrderStatus.length + selectedQuoteCategory.length);
  }, [selectedOrderStatus])

  useEffect(() => {
    document.addEventListener("mousedown", closeOpenMenus);
  }, [open]);

  useEffect(() => {
    if (!orderRadioSelected) {
      setSelectedGridOption(0);
    }
  }, [orderRadioSelected]);

  useEffect(() => {
    if (props.selectedGridOption !== undefined) {
      setSelectedGridOption(props.selectedGridOption);
    }
  }, [props.selectedGridOption]);

  const handleBionexoStatus = (selectedDashboardQuoteFilterProps: any) => {
    let newCatSelection: string[] = selectedBionexoStatus;

    if (selectedDashboardQuoteFilterProps.target.checked) {
      newCatSelection.push(selectedDashboardQuoteFilterProps.target.value);
    } else {
      newCatSelection = newCatSelection.filter(
        (cat: string) => cat !== selectedDashboardQuoteFilterProps.target.value
      );
    }
    setStatusBionexo([...newCatSelection]);
    !notReloadStatus && setCurrentPage(0);
    setLength!(newCatSelection.length + selectedViveoStatus.length + selectedQuoteCategory.length);
  };

  const handleViveoStatus = (selectedDashboardQuoteFilterProps: any) => {
    let newCatSelection: string[] = selectedViveoStatus;

    if (selectedDashboardQuoteFilterProps.target.checked) {
      newCatSelection.push(selectedDashboardQuoteFilterProps.target.value);
    } else {
      newCatSelection = newCatSelection.filter(
        (cat: string) => cat !== selectedDashboardQuoteFilterProps.target.value
      );
    }
    setStatusViveo([...newCatSelection]);
    !notReloadStatus && setCurrentPage(0);
    setLength!(selectedBionexoStatus.length + selectedQuoteCategory.length + newCatSelection.length);
  };

  const handleQuoteCategory = (selectedDashboardQuoteFilterProps: any) => {
    let newCatSelection: string[] = selectedQuoteCategory;

    if (selectedDashboardQuoteFilterProps.target.checked) {
      newCatSelection.push(selectedDashboardQuoteFilterProps.target.value);
    } else {
      newCatSelection = newCatSelection.filter(
        (cat: string) => cat !== selectedDashboardQuoteFilterProps.target.value
      );
    }
    setQuoteCategory([...newCatSelection]);
    !notReloadStatus && setCurrentPage(0);
    !orderRadioSelected && setLength!(selectedBionexoStatus.length + selectedViveoStatus.length + newCatSelection.length);
    orderRadioSelected && setLength!(selectedOrderStatus!.length + newCatSelection.length);
  };

  const handleOrderStatus = (selectedDashboardOrderFilterProps: any) => {
    let newStatusSelection: string[] = selectedOrderStatus!;

    if (selectedDashboardOrderFilterProps.target.checked) {
      newStatusSelection.push(selectedDashboardOrderFilterProps.target.value);
    } else {
      newStatusSelection = newStatusSelection.filter((status: string) => status !== selectedDashboardOrderFilterProps.target.value);
    }
    setStatusBionexo([]);
    setStatusViveo([]);
    setOrderStatus!([...newStatusSelection]);
    !notReloadStatus && setCurrentPage(0);
    setLength!(selectedOrderStatus!.length + selectedQuoteCategory.length + newStatusSelection.length);
  };

  const handleGridOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const v = Number(event.target.value) as 0 | 1 | 2;
    setSelectedGridOption(v);
    props.setSelectedGridOption?.(v);
  };

  const renderQuoteOptions = () => {
    return (
      <>
        <li className="StatusFilterStatusPlace">Status Bionexo</li>
        <ul>
          {searchListBionexo.map((value) => {
            return (
              <li className="StatusFilterStatusRow" key={value.value}>
                <label className="StatusFilterStatusItem">
                  <input
                    type="checkbox"
                    onChange={(event) => handleBionexoStatus(event)}
                    value={value.value}
                    name={`opt-${value.status}`}
                    className="StatusFilterCheckbox"
                    checked={!!props.selectedBionexoStatus.find(element => element === value.value)}
                  />
                  <span className="StatusFilterCheckbox"></span>
                  <span className="StatusFilterStatusLabel">
                    {value.status}
                  </span>
                </label>
              </li>
            );
          })}
        </ul>
        <li className="StatusFilterStatusPlace">Status Viveo</li>
        <ul>
          {searchListViveo.map((value) => {
            return (
              <li className="StatusFilterStatusRow" key={value.value}>
                <label className="StatusFilterStatusItem">
                  <input
                    type="checkbox"
                    onChange={(event) => handleViveoStatus(event)}
                    value={value.value}
                    name={`opt-${value.status}`}
                    className="StatusFilterCheckbox"
                    checked={!!props.selectedViveoStatus.find(element => element === value.value)}
                  />
                  <span className="StatusFilterCheckbox"></span>
                  <span className="StatusFilterStatusLabel">
                    {value.status}
                  </span>
                </label>
              </li>
            );
          })}
        </ul>

      </>
    );
  };

  const renderOrderOptions = () => {
    return (
      <>
        <li className="StatusFilterStatusPlace">Status do pedido</li>
        <ul>
          {searchOrderOptions!.map((value) => {
            return (
              <li className="StatusFilterStatusRow" key={value.value}>
                <label className="StatusFilterStatusItem">
                  <input
                    type="checkbox"
                    onChange={(event) => handleOrderStatus(event)}
                    value={value.value}
                    name={`opt-${value.status}`}
                    className="StatusFilterCheckbox"
                    checked={!!props.selectedOrderStatus!.find(element => element === value.value)}
                  />
                  <span className="StatusFilterCheckbox"></span>
                  <span className="StatusFilterStatusLabel">
                    {value.status}
                  </span>
                </label>
              </li>
            );
          })}
        </ul>
      </>
    );
  };

  const renderGridOptions = () => {
    const options = [
      { value: 0, label: 'Todos os pedidos' },
      { value: 1, label: 'Novos resgates' },
      { value: 2, label: 'Pedidos já baixados' }
    ];

    return (
      <>
        <li className="StatusFilterStatusPlace">Exibir na Grid</li>
        <ul>
          {options.map((option) => (
            <li key={option.value}>
              <div className="StatusFilterStatusRadio">
                <input
                  type="radio"
                  onChange={handleGridOptionChange}
                  value={option.value}
                  name="gridOption"
                  checked={selectedGridOption === option.value}
                />
                <label htmlFor="StatusFilterStatusLabel">{option.label}</label>
              </div>
            </li>
          ))}
        </ul>
      </>
    );
  };

  const renderOrderCategoryText = () => {
    return (
      <>
        {renderGridOptions()}
        <li className="StatusFilterStatusPlace">Categoria do pedido</li>
      </>
    );
  };

  const renderQuoteCategoryText = () => {
    return (
      <li className="StatusFilterStatusPlace">Categoria da cotação</li>
    );
  };

  return (
    <Row className="w-md-100">
      <Column className="w-md-100">
        <Row>
          <Text className="StatusFilterLabel" size={12}>
            Filtrar por categoria e status
          </Text>
        </Row>
        <div ref={dropdownMenu}>
          <Row>
            <Column className="w-md-100">
              <div
                className="StatusFilterDropDown w-md-100"
                style={{ borderColor: open ? "#0E4C54" : "#BEBEBE" }}
                onClick={() => {
                  handleOpenCloseDropDownMenu();
                }}
              >
                <Text size={12}>Filtros selecionados ({length})</Text>
                <img alt="arrow icon" src={arrow} />
              </div>
            </Column>
          </Row>
          <Row>
            <div className="StatusFilterOptionsArea" style={{ display: style }}>
              <div>
                <VisibilityConditional
                  condition={!!orderRadioSelected}
                  firstOption={() => renderOrderCategoryText()}
                  secondOption={() => renderQuoteCategoryText()}
                />
                <ul>
                  {searchQuoteCategoryOptions.map((value) => {
                    return (
                      <li className="StatusFilterStatusRow" key={value.value}>
                        <label className="StatusFilterStatusItem">
                          <input
                            type="checkbox"
                            onChange={(event) => handleQuoteCategory(event)}
                            value={value.value}
                            name={`opt-${value.status}`}
                            className="StatusFilterCheckbox"
                            checked={!!props.selectedQuoteCategory.find(element => element === value.value)}
                          />
                          <span className="StatusFilterCheckbox"></span>
                          <span className="StatusFilterStatusLabel">
                            {value.status}
                          </span>
                        </label>
                      </li>
                    );
                  })}
                </ul>
                <VisibilityConditional
                  condition={!!orderRadioSelected}
                  firstOption={() => renderOrderOptions()}
                  secondOption={() => renderQuoteOptions()}
                />
              </div>
            </div>
          </Row>
        </div>
      </Column>
    </Row>

  );
};
export default QuoteStatusFilter;
